<script type="text/javascript">
import vm from './commoni18n.js'
vm.$i18n.locale = sessionStorage.getItem('locale')

// 审核状态
const CHECK_STATUS = {
  '-': {
    VALUE: '-',
    FIELD: '-',
    NAME: vm.$t('status.未提交'),
    DESC: vm.$t('status.未提交')
  },
  SUBMITTED: {
    VALUE: 0,
    // 后台返回的字符，通过FIELD判断显示
    FIELD: 'SUBMITTED',
    NAME: vm.$t('status.待提交'),
    DESC: vm.$t('status.待提交')
  },
  PENDING: {
    VALUE: 1,
    FIELD: 'PENDING',
    NAME: vm.$t('status.待审核'),
    DESC: vm.$t('status.待审核')

  },
  VERIFIED: {
    VALUE: 2,
    FIELD: 'VERIFIED',
    NAME: vm.$t('status.审核通过'),
    DESC: vm.$t('status.审核通过')

  },
  REJECTED: {
    VALUE: 3,
    FIELD: 'REJECTED',
    NAME: vm.$t('status.未通过'),
    DESC: vm.$t('status.未通过')

  },
  CANCELED: {
    VALUE: 4,
    FIELD: 'CANCELED',
    NAME: vm.$t('status.已取消'),
    DESC: vm.$t('status.已取消')

  },
  DISABLED: {
    VALUE: 5,
    FIELD: 'DISABLED',
    NAME: vm.$t('status.已失效'),
    DESC: vm.$t('status.已失效')

  },
  FIRST_TRIAL: {
    VALUE: 5,
    FIELD: 'FIRST_TRIAL',
    NAME: vm.$t('status.已初审'),
    DESC: vm.$t('status.已初审')

  }
}

// 审图状态颜色
function statusColor(status) {
  if (status === CHECK_STATUS.SUBMITTED.FIELD) {
    return 'color: #aaaaaa'
  }
  if (status === CHECK_STATUS.REJECTED.FIELD) {
    return 'color: #d10100'
  }
  if (status === '-') {
    return 'color: #d10100'
  }
  if (status === CHECK_STATUS.PENDING.FIELD) {
    return 'color: #E6A23C'
  }
  if (status === CHECK_STATUS.FIRST_TRIAL.FIELD) {
    return 'color: #1f7fc5'
  }
  if (status === CHECK_STATUS.DISABLED.FIELD) {
    return 'color: #aaaaaa'
  }
  if (status === CHECK_STATUS.VERIFIED.FIELD) {
    return 'color: #37bc9a'
  }
  return 'color: #666'
}

// 审图状态名称
function statusName(status) {
  if (status === '-') {
    return vm.$t('status.未提交')
  }
  if (status === CHECK_STATUS.PENDING.FIELD) {
    return vm.$t('status.待审核')
  }
  if (status === CHECK_STATUS.FIRST_TRIAL.FIELD) {
    return vm.$t('status.已初审')
  }
  if (status === CHECK_STATUS.REJECTED.FIELD) {
    return vm.$t('status.未通过')
  }
  if (status === CHECK_STATUS.VERIFIED.FIELD) {
    return vm.$t('status.审核通过')
  }
  if (status === CHECK_STATUS.DISABLED.FIELD) {
    return vm.$t('status.已失效')
  }
  if (status === CHECK_STATUS.CANCELED.FIELD) {
    return vm.$t('status.已取消')
  }
  if (status === CHECK_STATUS.SUBMITTED.FIELD) {
    return vm.$t('status.待提交')
  }
}

// 返回性别中文
function gender(val) {
  if (val === 'MALE') {
    return vm.$t('status.男')
  }
  if (val === 'FEMALE') {
    return vm.$t('status.女')
  }
}
// 暴露出这些属性和方法
export default {
  CHECK_STATUS,
  statusColor,
  statusName,
  gender

}
</script>



// WEBPACK FOOTER //
// src/common/checkDrawingCommon.vue